export default "__VITE_ASSET__DgMUpjUb__"